import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CopyToClipboardDirective } from '@shared/ui';
import { ContentLoaderModule } from '@spaq/shared/components/content-loader';
import { PipesModule } from '@spaq/shared/pipes.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	declarations: [],
	exports: [CommonModule, PipesModule, ContentLoaderModule, TranslateModule, RouterModule, CopyToClipboardDirective],
	imports: [TranslateModule, CopyToClipboardDirective],
	providers: []
})
export class SharedCommonModule {}
